import { Marker, MarkerClusterer } from '@googlemaps/markerclusterer';
import { Loader } from '@googlemaps/js-api-loader';
import { fetchIcon } from '../basisIcon';
import { GoogleMapsStyles } from './partials/_styles';

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="basis-maps"]';

/**
 * Friendation component
 */
export const basisMaps = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    /**
     * Google Maps implementation with multiple Marker elements
     */
    const handleMaps = () => {
      /** Elements that contain information for markers */
      const markerElements: HTMLElement[] = Array.from(
        component.querySelectorAll('.marker')
      );

      const mapsElement: HTMLElement = component.querySelector('.maps');

      const loader = new Loader({
        apiKey: 'AIzaSyBca3YHxXwxli2tlVpBByzP6SHEDaJID0s',
        version: 'weekly',
        libraries: ['places']
      });

      const mapOptions: google.maps.MapOptions = {
        styles: GoogleMapsStyles
      };

      let map: google.maps.Map;

      loader
        .importLibrary('maps')
        .then(({ Map }) => {
          map = new Map(mapsElement, mapOptions);

          if (markerElements.length === 1) {
            map.setZoom(14);

            map.setCenter({
              lat: parseFloat(markerElements[0].dataset.lat),
              lng: parseFloat(markerElements[0].dataset.lng)
            });
          } else {
            const bounds = new google.maps.LatLngBounds();
            markerElements.forEach((markerElement) => {
              bounds.extend({
                lat: parseFloat(markerElement.dataset.lat),
                lng: parseFloat(markerElement.dataset.lng)
              });
            });
            map.fitBounds(bounds);
          }

          buildMarkers();
        })
        .catch((e) => {
          console.error(e);
        });

      const buildMarkers = async () => {
        const markers: Marker[] = [];

        /**
         * SVG map marker template
         */
        const svgMarker = await fetchIcon('/assets/icons/pin.svg');

        markerElements.forEach((markerElement) => {
          const marker = new google.maps.Marker({
            position: {
              lat: parseFloat(markerElement.dataset.lat),
              lng: parseFloat(markerElement.dataset.lng)
            },
            icon: {
              url:
                'data:image/svg+xml;charset=UTF-8,' +
                encodeURIComponent(svgMarker),
              scaledSize: new google.maps.Size(33, 48)
            }
          });
          markers.push(marker);

          /**
           * Maps Marker InfoWindow
           * @type {google.maps.InfoWindow}
           */
          const infoWindow = new google.maps.InfoWindow({
            content: `<div class="popup">${markerElement.innerHTML}</div>`,
            maxWidth: 350,
            minWidth: 150
          });

          marker.addListener('click', function () {
            infoWindow.open(map, marker);
          });
        });

        // use default algorithm and renderer
        new MarkerClusterer({ map, markers });
      };
    };

    handleMaps();
  });
};
